import type { LookupType } from '@/enums/lookup-type';
import type { ManualDataVendorItem } from '@/types/data/manual';

export class ThingData {
    public bonusIds?: number[];
    public classId: number;
    public difficulty: string;
    public extraParams: Record<string, string>;
    public linkId: number;
    public linkType: string;
    public quality: number;
    public tooltip: string;

    constructor(
        public item: ManualDataVendorItem,
        public userHas: boolean,
        public lookupId: number,
        public lookupType: LookupType
    ) {
        this.extraParams = {};
    }
}
